import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { CheckboxLabelProps } from "./Checkbox.types";

export const checkboxLabelCSS = ({ iconPosition }: Pick<CheckboxLabelProps, "iconPosition">) =>
  css({
    display: "inline-flex",
    alignItems: "center",
    flexDirection: iconPosition === "right" ? "row-reverse" : "row",
    justifyContent: iconPosition === "right" ? "space-between" : "flex-start",

    gap: vars.spacing[2],

    padding: `${vars.spacing["05"]} 0`,
    width: iconPosition === "right" ? "100%" : "fit-content",
    cursor: "pointer",

    "&:has(input:disabled) [data-checkbox-label]": {
      color: vars.semantic.color.textDisabled,
    },

    "input:disabled + .clay-checkbox-wrapper": {
      opacity: 0.3,
    },

    ":has(input:disabled)": {
      cursor: "not-allowed",
    },

    "&:hover": {
      "input:checked:not(:disabled) + .clay-checkbox-wrapper": {
        outlineColor: "transparent",
        backgroundColor: vars.semantic.color.actionPrimaryHover,
      },

      "input:not(:checked, :disabled) + .clay-checkbox-wrapper": {
        outlineColor: vars.semantic.color.borderHover,
      },
    },
  });

export const checkboxIconCSS = css({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",

  width: "16px",
  height: "16px",

  backgroundColor: vars.semantic.color.actionSecondary,
  borderRadius: "3.5px",
  color: vars.semantic.color.iconInverse,

  outline: `1px solid ${vars.semantic.color.borderMinimal}`,
  outlineOffset: "-1px",

  transition: "all ease-out 100ms",

  cursor: "pointer",

  ".clay-checkbox-icon": {
    display: "none",
  },

  "&:where(input:checked + &)": {
    backgroundColor: vars.semantic.color.actionPrimary,
    outlineColor: "transparent",

    ".clay-checkbox-icon": {
      display: "block",
    },
  },

  "&:where(input:disabled + &)": {
    opacity: 0.3,
    cursor: "not-allowed",
    color: vars.semantic.color.iconDisabled,
  },

  "&:where(input:disabled:not(:checked) + &)": {
    backgroundColor: vars.semantic.color.actionSecondaryDisabled,
  },

  "&:where(input:checked:not(:disabled) + &):hover": {
    outlineColor: "transparent",
    backgroundColor: vars.semantic.color.actionPrimaryHover,
  },

  "&:where(input:not(:checked, :disabled) + &):hover": {
    outlineColor: vars.semantic.color.borderMinimal,
    backgroundColor: vars.semantic.color.actionSecondaryHover,
  },
});
